import { render, staticRenderFns } from "./stationDesc.vue?vue&type=template&id=00c63ac2&scoped=true"
import script from "./stationDesc.vue?vue&type=script&lang=js"
export * from "./stationDesc.vue?vue&type=script&lang=js"
import style0 from "./stationDesc.vue?vue&type=style&index=0&id=00c63ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c63ac2",
  null
  
)

export default component.exports